var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgP = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23.121,
  height: 24.254
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-755.796 -185.949)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7.932,
  height: 24.254,
  fill: "#1487c9",
  rx: 1.535,
  transform: "translate(755.796 185.949)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ee7d00",
  d: "m778.467 190.343-3.944-3.945a1.54 1.54 0 0 0-1.085-.449h-6.895a1.535 1.535 0 0 0-1.535 1.535v14.951a1.535 1.535 0 0 0 1.535 1.535h6.893a1.54 1.54 0 0 0 1.088-.451l3.945-3.961a1.54 1.54 0 0 0 .448-1.084v-7.046a1.53 1.53 0 0 0-.45-1.085"
}))));
export { SvgP as ReactComponent };
export default __webpack_public_path__ + "static/media/p.e8f1f26b.svg";